/**
 * @typedef {Object} Role
 * @property {string} name - The role name
 * @property {string|null} description - The role description (can be null)
 * @property {Array<string>} claims - Array of claim strings assigned to the role
 */

/**
 * @typedef {Object} SearchState
 * @property {boolean} isSearching - Boolean indicating if a search is active
 * @property {string|null} search - The search term, or null if no search
 */

/**
 * Filter roles based on search term matching name, description, or claims.
 * Performs case-insensitive matching against role name, description, and all claims.
 * Returns all roles when no search is active. Handles null descriptions gracefully.
 *
 * @param {Role} role - The role object to check against the search filter
 * @param {SearchState} searchState - The search state containing search term and status
 * @returns {boolean} Boolean indicating if the role matches the search filter
 */
export const filterRole = (role, searchState) => {
  if (!searchState.isSearching) return true

  const lowered = searchState.search.toLowerCase()
  return (
    role.name.toLowerCase().includes(lowered) ||
    (role.description != null && role.description.toLowerCase().includes(lowered)) ||
    role.claims.map(claim => claim.toLowerCase().includes(lowered)).filter(claim => claim).length > 0
  )
}
